import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TermsService } from './terms.service';
import { SppdashboardService } from '../dashboard/sppdashboard.service';
import { environment } from 'src/environments/env';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  standalone: false,
  styleUrl: './terms.component.scss'
})
export class TermsComponent {
  userId: any;
  constructor(private termsService: TermsService, private router: Router, private route: ActivatedRoute,private _sppdashboardService:SppdashboardService) { }
  public access: boolean = true;
  public _currentLogin = new BehaviorSubject<string | null>(null); // Initial value is null

  public currentLogin$: Observable<string | null> = this._currentLogin.asObservable();
  private linkSource = new BehaviorSubject<string>('default');
  currentLogin = this.linkSource.asObservable();

  ngOnInit() {
    this.getuser();
  }

  getuser() {
    this._sppdashboardService.getUser().subscribe((response: any) => {
      this.userId = response.data.userid;
    });
  }
  onTermsAccepted(isTermsAgreed: boolean) {
    this.termsService.updateTermsandCondition(isTermsAgreed , this.userId).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.router.navigateByUrl('/login');
        }
        if (!res.success) {
          window.open(environment.BASE_URL + "/ptp/security/ssoLogout?entryPoint=" + environment.APP_URL + "/#/prelogin", '_self')
        }
      },
      error:(error:any)=>{
        console.log(error);
        
      }
    })
  }

}
